import { apiRoutes } from 'routes';
import Fetcher from 'utils/fetcher';
import { TableFilterQueryParams } from 'types/tableFilter';
import { IIndustry } from 'domain/industry/types';

export type IndexParams = {
  clientId: ID;
  queryParams: TableFilterQueryParams;
};

const IndustriesRepository = {
  index({ clientId, queryParams }: IndexParams): Promise<CollectionResponse<'industries', IIndustry[]>> {
    const url = apiRoutes.apiSiteV1ClientIndustriesPath(clientId);
    return Fetcher.get(url, queryParams);
  },
};

export default IndustriesRepository;
